export default __webpack_public_path__ + "static/media/116_mobile.0fe6ad8d.jpg";